<template>
  <div class="panelContent" :style="{width: '100%'}">
    <div class="row center-xs">
      <div v-if="panel.title && panel.title.text" class="col-xs-12 mar-b20">
        <span class="textLarge" :style="{'font-size': panel.autofit ? (panel.width * 0.3) + 'vw' : panel.title.size + 'px', color: panel.title.colour}">{{panel.title.text}}</span>
      </div>
      <div class="col-xs-12 textXLarge">
        <table :style="{'font-size': panel.autofit ? (0.035 * panel.width * definition.formattingOptions.length) + 'vw' : panel.content.size + 'px', color: panel.content.colour, width: '100%'}">
          <thead>
            <th v-for="(column) in definition.formattingOptions" :key="column.name" :class="{hide: column.hidden}">{{column.label}}</th>
          </thead>
          <tbody>
            <tr v-for="(row, index) in data || []" :key="index">
              <td v-for="column in definition.formattingOptions" :key="column.name" :style="{backgroundColor: alarmOverrides[index].overrideBackgroundColour}" :class="{hide: column.hidden}">{{format(column, row[column.name])}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import alarmChecker from "../../../utils/alarms";
import moment from "moment";
export default {
  props: ["panel", "data", "definition"],
  data() {
    return {
      alarmOverrides: []
    };
  },
  methods: {
    format(column, value) {
      let val = value;
      switch (column.type) {
        case "duration":
          if (column.format) {
            val = moment.utc(val * 1000).format(column.format);
          } else {
            val = moment.duration(val).humanize();
          }
          break;
        case "epoch":
          val = moment(val * 1000).format(column.format || "HH:mm:ss");
          break;
      }
      return val;
    },
    checkAlarms() {
      this.alarmOverrides = [];
      if (!this.data || !this.data.length) return;
      this.data.forEach((data, index) => {
        let triggered;
        if (this.panel.alarms && this.panel.alarms.length) {
          this.panel.alarms.forEach(alarm => {
            if (triggered) return;
            if (alarmChecker.check(alarm, this.definition, data)) triggered = alarm;
          });
        }
        if (triggered) {
          this.alarmOverrides[index] = {
            overrideBackgroundColour: triggered.backgroundColour,
            overrideColour: triggered.colour
          };
        } else {
          this.$set(this.alarmOverrides, index, {
            overrideBackgroundColour: "",
            overrideColour: ""
          });
        }
      });
    }
  },
  watch: {
    data: {
      deep: true,
      handler: function(val, oldVal) {
        this.checkAlarms();
      }
    }
  }
};
</script>

<style>
</style>
